module.exports = __webpack_public_path__ + "img/whatsapp.f6142fc5.svg";